import {
  Component,
  h,
  Prop,
  Element,
  Event,
  type EventEmitter,
  State,
  getAssetPath,
} from '@stencil/core';
import { imagePlaceholderSVG } from '../../variables';
@Component({
  tag: 'uiaas-thumbnail',
  styleUrl: 'uiaas-thumbnail.scss',
  shadow: true,
})
export class UiaasThumbnail {

  @Prop() readonly src: string;

  @Prop() readonly alt: string;

  @Prop() readonly size?: string;

  @Prop() readonly customLazyLoading: boolean = false;

  @Prop() readonly nativeLazyLoading: boolean = true;

  /**
   * Disables both native and custom lazy loading for critical images (e.g., LCP).
   * When true, uses imagePlaceholderSVG for initial load if no src is provided.
   */
  @Prop() readonly disableLazyLoading: boolean = true;

  @Prop() readonly width?: number;

  @Prop() readonly height?: number;


  @State() hasError = false;

  // @State() private imagePlaceholderSVG = getAssetPath('assets/svg/image_placeholder.svg');
  @State() private imagePlaceholderSVG = imagePlaceholderSVG;

  @Element() el: HTMLElement;

  @Event({
    eventName: 'uiaas:thumbnail-loaded',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    thumbnailLoaded: EventEmitter;

  private handleImageLoad() {
      this.thumbnailLoaded.emit(this.el);
  }

  private handleImageError(e: Event) {
      (e.target as HTMLImageElement).src = this.imagePlaceholderSVG;
      this.hasError = true;
  }

  render() {
      // Use SVG placeholder for LCP image if disableLazyLoading is true and no src
      const useSvgPlaceholder = this.disableLazyLoading && !this.src;
      const isLazyLoading = this.customLazyLoading || this.nativeLazyLoading;
      const src = useSvgPlaceholder
        ? this.imagePlaceholderSVG
        : this.disableLazyLoading || !this.customLazyLoading
          ? this.src || this.imagePlaceholderSVG
          : this.imagePlaceholderSVG;
      const dataSrc = this.customLazyLoading && !this.disableLazyLoading ? this.src : null;

      return (
        <img
          class={{ 'svs-thumbnail': true, [this.size]: !!this.size }}
          src={this.hasError ? this.imagePlaceholderSVG : src}
          data-src={dataSrc}
          alt={this.alt || 'search result image'}
          {...{ fetchpriority: useSvgPlaceholder ? 'high' : 'low' }}
          loading={this.hasError || useSvgPlaceholder ? 'eager' : isLazyLoading ? 'lazy' : 'eager'}
          width={this.width ?? 140}
          height={this.height ?? 140}
          data-has-error={this.hasError}
          onLoad={() => this.handleImageLoad()}
          onError={(e) => this.handleImageError(e)}
        />
      );
  }
}